import { render } from "./Worker.vue?vue&type=template&id=58604056"
import script from "./Worker.vue?vue&type=script&lang=js"
export * from "./Worker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__